module.exports = __webpack_public_path__ + "img/green_antenna.59bb26c9.svg";